import { all, put, call, takeLatest } from 'redux-saga/effects';
import ApiService from '@/services/Api';
import { message } from 'antd';
import actions, { actionTypes } from './actions';
import leadActions from '../lead/actions';

function* generateLeadProposal({ payload }) {
  const hideMessage = message.loading('Proposal is being generated. Please wait.', 0);
  try {
    const { data } = yield call(ApiService.generateLeadProposal, {
      pk: payload.id,
    });
    hideMessage();
    yield put(actions.generateProposalSuccess(data));
    yield put(leadActions.fetchLead(payload.leadId));
  } catch (error) {
    yield put(actions.generateProposalFailed(error));
    yield put(actions.setLoadingPercent(0));
  }
}

function* createQuote({ payload }) {
  const hideMessage = message.loading('Quote is generating. Please wait.', 0);
  try {
    const { data } = yield call(ApiService.createQuote, {
      lead: payload.leadId,
      ...payload.values,
    });
    hideMessage();
    yield put(actions.createQuoteSuccess(data));
    yield put(leadActions.fetchLead(payload.leadId));
  } catch (error) {
    hideMessage();
    yield put(actions.createQuoteFailed(error));
    yield put(actions.showQuotesPrevalidateMessages({ messages: error.response?.data, leadId: payload.leadId }));
    yield put(leadActions.fetchLead(payload.leadId));
  }
}

function* createPaceQuote({ payload }) {
  const hideMessage = message.loading('PACE Quote is generating. Please wait.', 0);
  try {
    const { data } = yield call(ApiService.createPaceQuote, {
      lead: payload.leadId,
      ...payload.values,
    });
    hideMessage();
    yield put(actions.createPaceQuoteSuccess(data));
    yield put(leadActions.fetchLead(payload.leadId));
  } catch (error) {
    hideMessage();
    yield put(actions.createPaceQuoteFailed(error));
    yield put(leadActions.fetchLead(payload.leadId));
  }
}

function* setProposalActive({ payload }) {
  const hideMessage = message.loading('Setting Proposal as Active. Please wait.', 0);
  try {
    const { data } = yield call(ApiService.setProposalActive, payload.id, { is_active: payload.isActive });
    hideMessage();
    yield put(actions.setProposalActiveSuccess(data));
    yield put(leadActions.fetchLead(payload.leadId));
  } catch (error) {
    hideMessage();
    yield put(actions.setProposalActiveFailed(error));
  }
}

function* requestProposal({ payload }) {
  const hideMessage = message.loading('Request initiated. Please wait.', 0);
  try {
    const { data } = yield call(ApiService.requestProposal, payload.id, {
      request_proposal: payload.request_proposal,
    });
    hideMessage();
    yield put(actions.requestProposalSuccess(data));
    yield put(leadActions.fetchLead(payload.leadId));
  } catch (error) {
    hideMessage();
    yield put(actions.requestProposalFailed(error));
  }
}

function* unlockRequestedProposal({ payload }) {
  const hideMessage = message.loading('Unlocking. Please wait.', 0);
  try {
    const { data } = yield call(ApiService.unlockRequestedProposal, {
      lead_id: payload.id,
    });
    hideMessage();
    yield put(actions.unlockRequestedProposalSuccess(data));
    yield put(leadActions.fetchLead(payload.id));
  } catch (error) {
    hideMessage();
    yield put(actions.unlockRequestedProposalFailed(error));
  }
}

export default function* () {
  yield all([
    takeLatest(actionTypes.GENERATE_PROPOSAL, generateLeadProposal),
    takeLatest(actionTypes.CREATE_QUOTE, createQuote),
    takeLatest(actionTypes.CREATE_PACE_QUOTE, createPaceQuote),
    takeLatest(actionTypes.SET_PROPOSAL_ACTIVE, setProposalActive),
    takeLatest(actionTypes.REQUEST_PROPOSAL, requestProposal),
    takeLatest(actionTypes.UNLOCK_REQUESTED_PROPOSAL, unlockRequestedProposal),
  ]);
}
